import { actionTypes } from 'redux-form';
import moment from 'moment';

export default {
    events: (state, action) => {
        switch (action.type) {

            case actionTypes.CHANGE:
                if (
                    action.meta.form === 'events'
                    && action.meta.field === 'startDate'
                    && moment(action.payload).isSame(moment.now(), 'day')
                ) {
                    return {
                        ...state,
                        values: {
                            ...state.values,
                            isArchived: false,
                        }
                    };
                }

                return state;

            default:
                return state;

        // eslint-disable-next-line
        };
    }
};



// WEBPACK FOOTER //
// ./src/reducers/formPluginReducer.js